// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1e7tp","colMin":"styles_colMin__1uE4e"};